import { useDocumentTypes } from "@/features/documents/useDocumentTypes";
import { formatDocumentType } from "@/lib/formatDocumentType";

export function DocumentTypeLabel({ typeKey }: { typeKey: string }) {
  const { data } = useDocumentTypes();
  return <>{formatDocumentType(typeKey, data)}</>;
}
